import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ChatMessageReplyModalUI from './ChatMessageReplyModalUI.js'

class ChatMessageReplyModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      // bankAccountNum: this.props.loanBankAccountNum,
      // bankAccountNumError: null,
      message: '',
      messageError: null,
    }
  }

  render() {
    return (
      <ChatMessageReplyModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        replyMode={this.props.replyMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        message={this.state.message}
        onMessageChange={(event) => { this.setState({ message: event.target.value }) }}
        messageError={this.state.messageError}
        setMessageError={(error) => { this.setState({ messageError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    if (this.props.selectedAccountId) {
      RestApiUtils.post(this.props.context,
        `/api/su/accounts/${this.props.selectedAccountId}/users/${this.props.selectedUserId}/chatMessages`,
          this.onSubmitCallback, {
          message: this.state.message,
        }
      )
    }

    if (!this.props.selectedAccountId) {
      RestApiUtils.post(this.props.context,
        `/api/su/phoneNumber/${this.props.selectedPhone}/chatMessages`,
          this.onSubmitCallback, {
          message: this.state.message,
        }
      )
    }
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 10)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(ChatMessageReplyModalSF)
